export default "__VITE_ASSET__BkqwT_3Z__"